<template>
      <div class="menu-bar mt-4">
        <SidebarMenuItem v-for="(item, index) in items" :key="index" :circleColor="groupColor" :item="item" :selected="selectedItem && selectedItem.uuid === item.uuid" @clicked="itemSelected(index, item)"/>
        <div v-if="showMore" class="col-12 mb-2 load-more-container" @click="$emit('loadMore', label)">
          <div :content="$t('sidebar.fetch_more')" v-tippy class="fill-parent load-more-inactive">
            <span class="load-more-icon sli-arrow-down"></span>
          </div>
        </div>
        <hr class="mt-3 mb-3 dotted-line" style="width:95%" v-if="items && items.length > 0"/>
      </div>
</template>

<script>
import SidebarMenuItem from '@/components/SidebarMenuItem.vue'
export default {
  components: {
    SidebarMenuItem
  },
  props: {
    groupColor: String,
    items: Array,
    selectedItem: Object,
    showMore: Boolean,
    label: String
  },
  computed: {
  },
  data: () => ({
  }),
  created () {
  },
  methods: {
    itemSelected: function (index, item) {
      this.$emit('itemSelected', item)
    }
  }
}
</script>

<style>
.load-more-container {
    background-color: var(--annotation-new-bg-color);
    -webkit-transition: background-color .15s ease-in-out;
    transition: background-color .15s ease-in-out;
    border-radius: 3px;
    font-size: xx-small;
    margin-top: 0.2em;
    width: 95%;
    height: 10px;
    padding: 3px;
    margin-left: 2em;
}
.load-more-container:hover {
  background-color: var(--annotation-new-hover-bg-color);
}
.load-more-inactive {
  text-align: center;
  position: relative;
}
.load-more-icon {
  position: absolute;
  top: -2px;
}
.menu-bar {
  padding-right: 1.5rem;
}
.menu-bar ul li {
  border-bottom: none;
}
.list-text {
  float: right;
}
.menu-item {
  width: 95%;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/SidebarMenu.vue